import Badge from 'antd/lib/badge';

interface StatusTagProps {
    status: 'CONFIRMED' | 'COMPLETED' | 'TERMINATED' | 'INACTIVE' | 'ACTIVE' | 'NEW' | (string & {});
}

export const StatusTag = ({ status }: StatusTagProps) => {
    if (!status) return <></>;

    switch (status?.toUpperCase()) {
        case 'NEW':
            return <Badge color="lime" text={status} />;
        case 'ACTIVE':
            return <Badge color="blue" text={status} />;
        case 'INACTIVE':
            return <Badge color="yellow" text={status} />;
        case 'TERMINATED':
            return <Badge color="#c6c6c6" text={status} />;
        case 'COMPLETED':
            return <Badge color="purple" text={status} />;
        case 'CONFIRMED':
            return <Badge color="green" text={status} />;
        default:
            return <Badge color="#c6c6c6" text={status} />;
    }
};
